import { ApplicationDto } from 'prequalificationV2/api/ApplicationApi';
import {
  AppDispatch,
  PreQualificationStep,
  setPreQualificationStep,
  setSignInStep,
  SignInStep,
} from 'prequalificationV2/actions';
import { setApplication } from 'prequalificationV2/actions/application';
import { setCoBorrower } from 'prequalificationV2/actions/coBorrower';
import { setDashboardStep } from 'prequalificationV2/actions/stages';
import { setPrequalificationPortal } from 'prequalificationV2/actions/prequalificationPortal';
import { ApplicationStatus } from 'enums/ApplicationStatus';
import { DashboardStep } from 'enums/DashboardStep';
import { LoanInformationVariables } from 'prequalificationV2/enums/LoanInformationVariables';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { NextStepDestination, NextStepNavigation } from 'prequalificationV2/utils/nextStepNavigation';

export const checkBorrower = ({
  borrowerApplication,
  hasCobborowerApplication,
  dispatch,
  navigator,
  navigation,
  shouldShowAlreadyHaveActiveApplication = false,
}: {
  borrowerApplication?: ApplicationDto;
  hasCobborowerApplication: boolean;
  dispatch: AppDispatch;
  navigator: (route: AppRoutes) => void;
  navigation: NextStepNavigation;
  shouldShowAlreadyHaveActiveApplication?: boolean;
}) => {
  const goToPrequalificationStep = (step: PreQualificationStep, isPrequalStepPreset?: boolean) => {
    if (isPrequalStepPreset) {
      dispatch(setPrequalificationPortal({ isPrequalStepPreset: true }));
    }

    dispatch(setPreQualificationStep(step));
    navigator(AppRoutes.Prequalification);
  };

  if (borrowerApplication) {
    const variables = borrowerApplication.variables;

    dispatch(
      setApplication({
        applicationId: borrowerApplication.id,
        [LoanInformationVariables.AssignedConsultant]: {
          name: variables.consultant_sender_name || '',
          position: variables.consultant_sender_position || '',
          email: variables.consultant_sender_email || '',
          phone: variables.consultant_sender_phone || '',
        },
        applicationStatus: borrowerApplication?.status?.name as ApplicationStatus,
      }),
    );
    dispatch(
      setCoBorrower({
        firstName: variables.coborrower_first_name as string,
        lastName: variables.coborrower_last_name as string,
      }),
    );

    switch (navigation.destination) {
      case NextStepDestination.CreateAccount:
        // Borrower completed the prequal flow but has not created a Portal account yet — send them to
        // the "Create Account" page instead of the Dashboard (DEV-2765 recovery logic).
        dispatch(setSignInStep(SignInStep.CreateAccount));
        navigator(AppRoutes.Login);
        break;
      case NextStepDestination.Prequalification:
        goToPrequalificationStep(navigation.prequalificationStep!, true);
        break;
      default:
        // Dashboard, or no actionable step from the backend — the borrower already has an application,
        // so land them on the Dashboard.
        if (shouldShowAlreadyHaveActiveApplication) {
          goToPrequalificationStep(PreQualificationStep.AlreadyHaveActiveApplication, true);
        } else {
          navigator(AppRoutes.Dashboard);
        }
    }
  } else if (hasCobborowerApplication) {
    goToPrequalificationStep(PreQualificationStep.BorrowerAsCoBorrowerAlreadyHaveActiveApplication);
  } else if (navigation.destination === NextStepDestination.Prequalification && navigation.prequalificationStep) {
    goToPrequalificationStep(navigation.prequalificationStep);
  } else {
    dispatch(setDashboardStep(DashboardStep.NoActiveApplication));
    navigator(AppRoutes.Dashboard);
  }
};
